const blacklistedExtensions = [
    // due to bad support on iPhone *
    "OES_texture_float", "OES_texture_float_linear",
    "OES_texture_half_float", "OES_texture_half_float_linear",
    "EXT_color_buffer_half_float", "WEBGL_color_buffer_float",
];

const blacklistedExtensionsMap: {[index: string]: boolean} = {};
blacklistedExtensions.forEach((name) => blacklistedExtensionsMap[name] = true);

export const WebGLWorkarounds = {
    apply: (canvas: HTMLCanvasElement, module: any, useTrl: boolean) => {
        const fn = canvas.getContext as any;
        canvas.getContext = (...args: any[]) => {
            const ctx = fn.apply(canvas, args);
            if (args[0] === "webgl") {
                canvas.getContext = fn;
                const whitelisted: string[] = [];
                const extensions = ctx.getSupportedExtensions();
                // tslint:disable-next-line:no-console
                console.log("Validating supported extensions", extensions);
                extensions.forEach((name: any) => {
                    if (blacklistedExtensionsMap[name] === true) {
                        // tslint:disable-next-line:no-console
                        console.warn("WARN! Removing blacklisted extension", name);
                    } else {
                        whitelisted.push(name);
                    }
                });
                ctx.getSupportedExtensions = () => whitelisted;
                if (useTrl) {
                    installTrlWatcher(ctx as WebGLRenderingContext, module);
                }
            }
            return ctx;
        };
    },
};

const trlState: {
    activeTexture: WebGLTexture | null,
} = {
    activeTexture: null,
}

function installTrlWatcher(gl: WebGLRenderingContext, module: any) {
    gl.bindTexture = ((oldBindTextureFn) => {
        return (target: GLenum, texture: WebGLTexture | null) => {
            if (target === gl.TEXTURE_2D) {
                trlState.activeTexture = texture;
            }
            return oldBindTextureFn(target, texture);
        };
    })(gl.bindTexture.bind(gl));


    gl.texImage2D = ((oldTexImage2DFn) => {
        // tslint:disable-next-line
        return (function(target: GLenum, level: GLint, internalformat: GLint, width: GLsizei, height: GLsizei,
                         border: GLint, format: GLenum, type: GLenum, pixels: ArrayBufferView | null) {
            if (target === gl.TEXTURE_2D && pixels !== undefined && pixels !== null && trlState.activeTexture !== null) {
                const bytes = new Uint8Array(pixels.buffer, pixels.byteOffset, pixels.byteLength);
                // @trl:
                if (bytes.length > 4 &&
                    bytes[0] === 64 && bytes[1] === 116 &&
                    bytes[2] === 114 && bytes[3] === 108 &&
                    bytes[4] === 58) {
                    const keyOffset = 5;
                    let keyLength = 0;
                    while (bytes[keyOffset + keyLength] !== 0 && bytes.length > keyOffset + keyLength) {
                        keyLength++;
                    }

                    const key = new TextDecoder("utf-8")
                        .decode(new Uint8Array(pixels.buffer,
                                               pixels.byteOffset + keyOffset,
                                               keyLength));

                    const keyBuffer = module._malloc(keyLength + 1);
                    module.stringToUTF8(key, keyBuffer, keyLength + 1);
                    module._gpxLoadTextureAsync((trlState.activeTexture as any).name, keyBuffer);
                    module._free(keyBuffer);

                    const imageData = new ImageData(1, 1);
                    return oldTexImage2DFn.apply(gl, [target, level, internalformat, format, type, imageData]);
                }
            }
            return oldTexImage2DFn.apply(gl, arguments as any);
        }) as any;
    })(gl.texImage2D.bind(gl));
}
